import { React, useState } from 'react';
import { Dropdown } from '../../atoms';
import './search-bar.scss';

import { default as t } from '../../../utils/i18n';

const SearchBar = ({
  onChange,
  value = '',
  onEnter = () => { },
  placeholder = t('insights.report.list.search.placeholder'),
  options,
  filterBy,
  onDropdownChange,
  optionalPropsNotRequired
}) => {
  
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      onEnter();
    }
  };

  const handleClear = e => {
    onChange('');
    onDropdownChange(options[0]);
  };

  const handleOnSelect = selectedOption => {
    onDropdownChange(selectedOption);
  };

  return (
    <div className='c-search-bar'>
      <div className='c-search-bar--input'>
        <i className='eva eva-search-outline search-icon'></i>
        <input
          className='c-search-input'
          type='text'
          placeholder={placeholder}
          value={value}
          name='search'
          onChange={e => {
            onChange(e.target.value);
          }}
          onKeyDown={handleKeyDown}
          autoComplete="off"
        />
      </div>
      {!optionalPropsNotRequired && <div className='c-search-bar--dropdown'>
        <Dropdown
          heading={t('insights.report.list.dropdown.placeholder')}
          value={filterBy}
          options={options}
          onSelect={handleOnSelect}
          customIndicator={true}
        />
      </div>}
      {!optionalPropsNotRequired && <div className='c-search-bar--clear' onClick={handleClear}>
        <i className='eva eva-close-outline clear-icon'></i>
      </div>}
    </div>
  );
};

export default SearchBar;
